import api from './api';

export const apiKeyService = {
    async setAPIKey(apiKey) {
        const response = await api.put('/api-key/set', {
            gemini_api_key: apiKey,
        });
        return response.data;
    },

    async removeAPIKey() {
        const response = await api.delete('/api-key/remove');
        return response.data;
    },

    async getAPIKeyStatus() {
        const response = await api.get('/api-key/status');
        return response.data;
    },
};
